module.exports = __webpack_public_path__ + "img/HappyPhoto29.52c9744b.jpeg";